import { render, staticRenderFns } from "./Page001.vue?vue&type=template&id=f165b2fa&scoped=true&"
import script from "./Page001.vue?vue&type=script&lang=js&"
export * from "./Page001.vue?vue&type=script&lang=js&"
import style0 from "./Page001.vue?vue&type=style&index=0&id=f165b2fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f165b2fa",
  null
  
)

export default component.exports